module.exports = __webpack_public_path__ + "img/salsa_1969.34942db7.jpg";